export default Object.freeze({
  Inline: 'inline',
  Popup: 'popup',
});
